/**
 * Move the router to a URL that arrived from outside the page — a deep link the
 * OS handed us, or a tapped notification.
 *
 * Assigning `location` would work but reloads the whole bundle and replays the
 * splash, so this pushes the path and fires the event the router listens for
 * instead. Only the path is used: the origin an external link carries is
 * master-splitter.com, while the app itself runs on https://localhost.
 *
 * Returns false for a URL that will not parse, so callers can ignore it.
 */
export function inAppNavigate(url) {
    try {
        const target = new URL(url, window.location.origin)
        window.history.pushState({}, '', target.pathname + target.search + target.hash)
        window.dispatchEvent(new PopStateEvent('popstate'))
        return true
    } catch {
        return false
    }
}
